import { getOffersByProductId, getProductBySlug } from '../utils/api';
import {
  formatOfferPrice,
  getComparableOfferPrice,
  getOfferLink,
  getRetailerNameFromOffer,
} from './comparisons/comparisonOffers';
import { getDisplayImageSrc } from './PriceComparison/simpleProductPageShared';
import {
  formatCurrentOfferFreshness,
  getCurrentOfferHeadline,
  selectCurrentVerifiedBest,
} from '../domain/offerFreshness';

export const HOME_COMMERCE_PRODUCTS = [
  {
    slug: 'livescope-2-lvs42hd',
    label: 'LiveScope 2 LVS42HD',
    fallbackImage: '/images/transducers/livescope-2-lvs42hd.jpg',
    pdpPath: '/simple-products/livescope-2-lvs42hd',
  },
  {
    slug: 'livescope-2-lvs44',
    label: 'LiveScope 2 LVS44',
    fallbackImage: '/images/transducers/livescope-2-lvs44.jpg',
    pdpPath: '/simple-products/livescope-2-lvs44',
  },
];

function emptyCommerceItem(item, extra = {}) {
  return {
    ...item,
    name: extra.name || item.label,
    imageSrc: extra.imageSrc || item.fallbackImage,
    offer: null,
    priceLabel: null,
    retailer: null,
    freshness: null,
    affiliateUrl: '',
    salePrice: null,
    hasCurrent: false,
    isTie: false,
    tiedCount: 0,
    kicker: 'Current price verification delayed',
    tieNote: null,
    offersResolved: true,
  };
}

export async function loadHomeCommerceItem(item) {
  try {
    const product = await getProductBySlug(item.slug);
    const imageSrc =
      getDisplayImageSrc(product?.image_url) || item.fallbackImage;
    const name = product?.name || item.label;

    if (!product?.id) {
      return emptyCommerceItem(item, { name, imageSrc });
    }

    const result = await getOffersByProductId(product.id);
    const selection = selectCurrentVerifiedBest(result?.data);
    const headline = getCurrentOfferHeadline(selection);
    const offer = selection.primary;

    if (!selection.hasCurrent || !offer) {
      return emptyCommerceItem(item, { name, imageSrc });
    }

    return {
      ...item,
      name,
      imageSrc,
      offer,
      priceLabel: formatOfferPrice(offer),
      retailer: getRetailerNameFromOffer(offer),
      freshness: formatCurrentOfferFreshness(offer),
      affiliateUrl: getOfferLink(offer),
      salePrice: getComparableOfferPrice(offer),
      hasCurrent: true,
      isTie: selection.isTie,
      tiedCount: selection.tied.length,
      kicker: headline.kicker,
      tieNote: headline.note,
      offersResolved: true,
    };
  } catch {
    return emptyCommerceItem(item);
  }
}
